<script>
import AdsType1 from "../../AdsType1.vue";
export default {
  extends: AdsType1,
  data() {
    return {
      style: {
        maxWidth: "382px",
        maxHeight: "178px"
      }
    };
  }
};
</script>
